import moment from "moment";

const columns = [
    {
        title: 'Symbol',
        dataIndex: 'symbol',
    },
    {
        title: 'Type',
        dataIndex: 'type',
        render: (text) => text === 'BUY' ? <span className="text-[#28C76F] bg-[#DDF6E8] p-1 px-2 rounded font-semibold" >Buy</span> : <span className="text-[#FF4C51] bg-[#FFE2E3] p-1 px-2 rounded font-semibold" >Sell</span>,
    },
    {
        title: 'Volume',
        dataIndex: 'volume',
    },
    {
        title: 'Open Price',
        dataIndex: 'priceOpen',
        render: (text) => `$ ${text}`,
        width: 150,
    },
    {
        title: 'Current Price',
        dataIndex: 'priceCurrent',
        render: (text) => `$ ${text}`,
        width: 150,
    },
    {
        title: 'S/L',
        dataIndex: 'stopLoss',
        render: (text) => `$ ${text}`,
    },
    {
        title: 'T/P',
        dataIndex: 'takeProfit',
        render: (text) => `$ ${text}`,
    },
    {
        title: 'Swap',
        dataIndex: 'swap',
        render: (text) => `$ ${text}`,
    },
    {
        title: 'Open Time',
        dataIndex: 'time',
        render: (text) => moment(text).format('DD-MM-YYYY LT'),
    },
    {
        title: 'P/L',
        dataIndex: 'profit',
        render: (text) => text > 0 ? <span className="text-[#28C76F] font-semibold" >$ {text?.toFixed(2)}</span> : <span className="text-[#FF4C51] font-semibold" >$ {text?.toFixed(2)}</span>,
        width: 120,
    },
    {
        title: 'Close', dataIndex: 'close', key: 'close', width: 80
    }
];

export default columns;
